import styled from 'styled-components';

const DropdownMenu = styled.div`
position: absolute;
flex-direction: column;
z-index: 2;
display: ${props => props.menuVisible ? 'flex' : 'none'};
background-color: #265a9c;
color: #ffffff;
width: 200px;
border-radius: 2px;
border: 1px solid #ffffff;
>div{
    cursor: pointer;
    padding: 2px 5px;
    :hover {
    background-color: #7099BE;
  }
}
`
export default DropdownMenu;


// WEBPACK FOOTER //
// ./src/components/DropdownMenu.jsx